import clsx from "clsx";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

interface Props {
  id: string;
  title: string;
  active: boolean;
  onClick: () => void;
}

export const DashboardItem = ({ id, title, active, onClick }: Props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <button
      ref={setNodeRef}
      style={style}
      className={clsx(
        "block w-full h-8 flex items-center justify-between gap-6 px-2",
        "border border-transparent rounded group",
        {
          "bg-v2-secondary border-v2-tertiary": active,
          "hover:bg-v2-secondary": !active,
          "relative bg-v2-secondary shadow-sm z-[1]": isDragging,
        },
      )}
      onClick={onClick}
    >
      <div className={clsx("truncate", { "text-v2-action font-bold": active })}>
        {title}
      </div>
      <div
        ref={setActivatorNodeRef}
        {...attributes}
        {...listeners}
        className="shrink-0 cursor-grab"
      >
        <i className="fa-solid fa-grip-dots text-v2-icon-secondary opacity-50 group-hover:opacity-100" />
      </div>
    </button>
  );
};
